import { render, staticRenderFns } from "./UpdateTypeDialog.vue?vue&type=template&id=4a35fdf0&"
import script from "./UpdateTypeDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTypeDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VForm,VIcon})
